import { render } from "./CustomBody.vue?vue&type=template&id=abcb4a2e&scoped=true"
import script from "./CustomBody.vue?vue&type=script&lang=js"
export * from "./CustomBody.vue?vue&type=script&lang=js"

import "./CustomBody.vue?vue&type=style&index=0&id=abcb4a2e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abcb4a2e"]])

export default __exports__